export default __webpack_public_path__ + "static/media/Nosotros-2.6e0717d4.webp";